import React from 'react';
import style from './displayEmoji.module.css';

export class BubblingPool extends React.PureComponent {
  constructor(props) {
    super(props);
    this.ref = props.register(props.name);
    this.poll = new Array(props.pollSize).fill(props.name);
  }

  render() {
    /*  const {
        name,
        pollSize,
      } = this.props;
  */

    return this.poll.map((name, index) => (
      <article
        key={`${name}#${index}`}
        data-allow-animation={index === 0}
        hidden={true}
        ref={this.ref}
        className={style.instance}
      >
        <div className={style.decorator} />
      </article>
    ));
  }
}
